export class EmailAddress {
  name: string;
  email: string;
}
